module.exports = __webpack_public_path__ + "img/ART_BG_pattern.5c2ca1e4.svg";